<script>
import THelp from '~/components/THelp';

export default {
  extends: THelp,

  props: {
    label: {
      type: String,
      required: false,
      default: `
        Im Auftritt Ihrer Firma verwenden Sie immer eine bestimmte Farbe, die Sie hier für die Bewerber:innen-Anschreiben festlegen können.<br/>
        Wenn Sie den Hexcode/Farbcode für Ihr Unternehmen nicht wissen, wenden Sie sich bitte an Ihre Marketingabteilung.`,
    },
  },
};
</script>
